import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M1,-3h0.5v0.5h-0.5zM0.5,-2.5h1v0.5h-1zM-0.5,-2h1.5v0.5h-1.5zM-0.5,-1.5h1v0.5h-1zM0,-1h0.5v2h-0.5zM-1,1h0.5v1h-0.5zM0,1h1v1h-1zM-1,2h2v0.5h-2zM-1.5,2.5h3.5v0.5h-3.5z',
    },
    {
      paint: [
        ['haybale', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-0.5,-2.5h0.5v0.5h-0.5zM-0.5,-1h0.5v3h-0.5z',
    },
    {
      paint: 'mapleRed',
      d: 'M0,-7.5h0.5v0.5h-0.5zM-1.5,-7h2.5v0.5h-2.5zM-1.5,-6.5h3.5v0.5h-3.5zM-2.5,-6h1v1h-1zM0.5,-6h1.5v0.5h-1.5zM0,-5.5h2.5v0.5h-2.5zM-3,-5h0.5v0.5h-0.5zM-1.5,-5h1.5v0.5h-1.5zM1,-5h2v0.5h-2zM-3.5,-4.5h1v0.5h-1zM-2,-4.5h1.5v0.5h-1.5zM2.5,-4.5h0.5v0.5h-0.5zM-3.5,-4h3v0.5h-3zM2.5,-4h1v0.5h-1zM-3.5,-3.5h1.5v0.5h-1.5zM0.5,-3.5h0.5v0.5h-0.5zM2,-3.5h1.5v0.5h-1.5zM-3.5,-3h4.5v0.5h-4.5zM1.5,-3h1.5v0.5h-1.5zM-3,-2.5h0.5v0.5h-0.5zM-2,-2.5h1.5v0.5h-1.5zM0,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'mapleCrimson',
      d: 'M0,-5h1v0.5h-1zM-0.5,-4.5h3v1h-3zM-2,-3.5h2.5v0.5h-2.5zM1,-3.5h1v0.5h-1z',
    },
    {
      paint: 'mapleOrange',
      d: 'M-1.5,-6h2v0.5h-2zM-1.5,-5.5h1.5v0.5h-1.5zM-2.5,-5h1v0.5h-1zM-2.5,-4.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 138,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M0,-2.5h1.5v0.5h-1.5zM-0.5,-2h1.5v0.5h-1.5zM-0.5,-1.5h1v0.5h-1zM0,-1h0.5v2h-0.5zM-1,1h0.5v1h-0.5zM0,1h1v1h-1zM-1,2h2v0.5h-2zM-1.5,2.5h3.5v0.5h-3.5z',
    },
    {
      paint: [
        ['haybale', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M1,-5h0.5v0.5h-0.5zM1,-3.5h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5zM-0.5,-1h0.5v3h-0.5z',
    },
    {
      paint: 'mapleOrange',
      d: 'M-0.5,-7.5h1v0.5h-1zM-1.5,-7h2.5v0.5h-2.5zM-1.5,-6.5h3v0.5h-3zM-2.5,-6h1v1h-1zM0.5,-6h1.5v0.5h-1.5zM0,-5.5h2.5v0.5h-2.5zM-3,-5h0.5v1h-0.5zM-1.5,-5h1.5v0.5h-1.5zM1.5,-5h1v0.5h-1zM-2,-4.5h1.5v0.5h-1.5zM-3,-4h2.5v0.5h-2.5zM2.5,-4h0.5v0.5h-0.5zM-3,-3.5h1v0.5h-1zM0.5,-3.5h0.5v0.5h-0.5zM2,-3.5h1v0.5h-1zM-3,-3h6v0.5h-6zM-3,-2.5h2.5v0.5h-2.5zM1.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'autumnRust',
      d: 'M0,-5h1v0.5h-1zM-0.5,-4.5h3v1h-3zM-2,-3.5h2.5v0.5h-2.5zM1.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'autumnGold',
      d: 'M-1.5,-6h2v0.5h-2zM-1.5,-5.5h1.5v0.5h-1.5zM-2.5,-5h1v0.5h-1zM-2.5,-4.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 132,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-1.5,-3h0.5v0.5h-0.5zM-0.5,-3h2.5v0.5h-2.5zM-1,-2.5h0.5v0.5h-0.5zM0,-2.5h1.5v0.5h-1.5zM-0.5,-2h1.5v0.5h-1.5zM-0.5,-1.5h1v0.5h-1zM0,-1h0.5v2h-0.5zM-1,1h0.5v1h-0.5zM0,1h1v1h-1zM-1,2h2v0.5h-2zM-1.5,2.5h3.5v0.5h-3.5z',
    },
    {
      paint: [
        ['haybale', 0.38],
        ['trunk', 0.62],
      ],
      d: 'M-1,-3h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5zM-0.5,-1h0.5v3h-0.5z',
    },
    {
      paint: 'mapleRed',
      d: 'M-1,-7h2v0.5h-2zM-2,-6.5h3v0.5h-3zM-2,-6h0.5v0.5h-0.5zM0.5,-6h1.5v0.5h-1.5zM-3,-5.5h1v0.5h-1zM0,-5.5h2v0.5h-2zM-3,-5h0.5v1h-0.5zM-1.5,-5h1.5v0.5h-1.5zM1.5,-5h0.5v0.5h-0.5zM-2,-4.5h1.5v0.5h-1.5zM-3.5,-4h2.5v0.5h-2.5zM-3.5,-3.5h1v0.5h-1zM-2.5,1h1v0.5h-1zM-1.5,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'mapleCrimson',
      d: 'M0,-5h1v0.5h-1zM-0.5,-4.5h3v1h-3zM-2,-3.5h2.5v0.5h-2.5zM1,-3.5h1v0.5h-1zM-2,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'autumnGold',
      d: 'M-1.5,-6h0.5v0.5h-0.5zM-0.5,-6h0.5v0.5h-0.5zM-1.5,-5.5h1.5v0.5h-1.5zM-2,-5h0.5v0.5h-0.5zM1.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['mapleRed', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M1,-5h0.5v0.5h-0.5zM-1,-4h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5zM2,-3.5h0.5v0.5h-0.5zM-2.5,1.5h1v0.5h-1z',
    },
    {
      paint: [
        ['autumnGold', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-1,-6h0.5v0.5h-0.5zM0,-6h0.5v0.5h-0.5zM-2,-5.5h0.5v0.5h-0.5zM-2.5,-5h0.5v1h-0.5zM1,0.5h0.5v0.5h-0.5zM1.5,1h0.5v0.5h-0.5z',
    },
    { paint: 'mapleOrange', d: 'M2.5,-1.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['mapleOrange', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M2,-2h0.5v1h-0.5z',
    },
  ],
  pixels: 129,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
